// IMPORTANT NOTE: Please don't import other selectors from this file.
// Use secondOrder and *ThirdOrder for your selector if it has other
// dependencies.

import { createSelector } from 'reselect'

import { newFileAudioClips } from '../store/newFileState'
import { fullFileStateSelector } from './fullFileFirstOrder'

/**
 * @typedef {import('../index').PlottrFileAudioClips} PlottrFileAudioClips
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../types/plottr').AudioClipRecord} AudioClipRecord
 */

/**
 * @type {function(PlottrState): PlottrFileAudioClips}
 */
export const allAudioClipsSelector = createSelector(fullFileStateSelector, ({ audioClips }) => {
  return audioClips ?? newFileAudioClips
})

/**
 * @param {PlottrState} _state
 * @param {number} id
 * @return {number}
 */
const selectId = (_state, id) => {
  return id
}

/**
 * @type {function(PlottrState, number): AudioClipRecord | null}
 */
export const singleAudioClipSelector = createSelector(
  allAudioClipsSelector,
  selectId,
  (audioClips, id) => {
    return audioClips[id] ?? null
  }
)
